<!--   Hidden form for form post to BankServ   -->
<ng-container *ngIf="initiateResponseCard">
    <form [action]="initiateResponseCard.acsUrl" method="post" id="acs-form-app" class="cdk-visually-hidden" hidden>
      <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden>
      <input name="PaReq" [value]="initiateResponseCard.acsPayload" id="PaReq" hidden>
      <input name="TermUrl" [value]="initiateResponseCard.acsTermUrl" id="TermUrl" hidden>
    </form>
  </ng-container>
  
  <div class="app-container sm:h-screen flex mb-4" *ngIf="!loading && session else default " [ngStyle]="{'background': backgroundImage}">
    <mat-card #matCard id="mat-card" class="bottom-border-radius w-full sm:wpx-450 md:wpx-650 lg:wpx-750 xl:wpx-800 md:min-h-600 bg-white-500 p-0 border-top-edges-rounded min-h-screen" [ngClass]="loading ? 'sm:max-h-600' : ''">
      <app-header>
      </app-header>
  <!--    <div class="mat-typography">-->
  <!--      <router-outlet></router-outlet>-->
  <!--    </div>-->
      <router-outlet></router-outlet>
    </mat-card>
  </div>
  
  
  <ng-template #default>
    <div class="app-container sm:h-screen flex mb-4" [ngStyle]="{'background': backgroundImage ? backgroundImage : defaultBackgroundImg}">
      <mat-card #matCard id="mat-card" class="flex items-center justify-center bottom-border-radius w-full sm:wpx-450 md:wpx-650 lg:wpx-750 xl:wpx-800 md:min-h-600 bg-white-500 p-0 border-top-edges-rounded min-h-screen" [ngClass]="loading ? 'sm:max-h-600' : ''">
  <!--      <app-header>-->
  <!--      </app-header>-->
  <!--      <router-outlet></router-outlet>-->
        <div *ngIf="errResponse" class="w-full mb-4" [ngStyle]="{'height': mobile ? '' : '', 'min-height': mobile ? '97vh' : '576px' }">
  <!--        <app-error-handling></app-error-handling>-->
          <app-header>
          </app-header>
          <router-outlet></router-outlet>
  <!--        <app-transaction-status></app-transaction-status>-->
        </div>
        <mat-spinner
          class="loading-spinner mb-4 mt-4"
          [color]="color"
          [diameter]="diameter"
          *ngIf="!errResponse"
        >
        </mat-spinner>
      </mat-card>
    </div>
  </ng-template>
  